var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":_vm.user_is_attorney ? 'Has the buyer signed <br>their property disclosures?' : 'Have you signed <br>your property disclosures?'}},[_c('input-radio-boolean',{attrs:{"name":"has_signed_disclosures","value":_vm.attorney.has_signed_disclosures,"true":"Yes","false":"No","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }